import { BIM360IssueActivity } from "./BIM360IssueActivity";

export enum BIM360IssueStatus {
    Draft = 'draft',
    Open = 'open',
    Closed = 'closed',
    WorkCompleted = 'work_completed',
    ReadyToInspect = 'ready_to_inspect',
    NotApproved = 'not_approved',
    InDispute = 'in_dispute',
    Void = 'void',
    Answered = 'answered'
};

const issueStatusFriendlyNames = {
    [BIM360IssueStatus.Draft]: 'Draft',
    [BIM360IssueStatus.Open]: 'Open',
    [BIM360IssueStatus.Closed]: 'Closed',
    [BIM360IssueStatus.WorkCompleted]: 'Work Completed',
    [BIM360IssueStatus.ReadyToInspect]: 'Ready to Inspect',
    [BIM360IssueStatus.NotApproved]: 'Not Approved',
    [BIM360IssueStatus.InDispute]: 'In Dispute',
    [BIM360IssueStatus.Void]: 'Void',
    [BIM360IssueStatus.Answered]: 'Answered'
};

export abstract class BIM360Issue {
    public id: string = '';
    public forgeId: string = '';
    public title: string = '';
    public description: string = '';
    public status: BIM360IssueStatus | null = null;
    public permittedStatuses: BIM360IssueStatus[] = [];
    public permittedAttributes: string[] = [];
    public issueSubtypeId: string = '';
    public issueTypeId: string = '';
    public assignedTo: string = '';
    public assignedToType: string = '';
    public location: string = '';
    public locationDescription: string = '';
    public owner: string = '';
    public dueDate: Date | null = null;
    public rootCauseId: string = '';
    public containerId: string | null = '';
    public customAttributes: any[] = [];
    public comment: string = "";
    public activities: BIM360IssueActivity[] = [];

    public abstract saveChanges();

    public static friendlyNameForStatus(status: BIM360IssueStatus) {
        return issueStatusFriendlyNames[status];
    }
}

export abstract class BIM360IssueCustomAttribute {
    public attributeDefinitionId: string = '';
    public title: string = '';
    public type: string = '';
    public value: string = '';
}